export default {"src":"/_next/static/media/audio.348dff6b.svg","height":240,"width":240,"blurWidth":0,"blurHeight":0};